'use client'

import { getProductsNavigation } from './product-category.utils'
import Link from 'next/link'
import { cn } from '@/lib/utils'
import { usePathname } from 'next/navigation'
import { use } from 'react'

type ProductNavigationProps = {
  navigation: ReturnType<typeof getProductsNavigation>
}

function ProductNavigation({ navigation }: ProductNavigationProps) {
  const navItems = use(navigation)

  const path = usePathname()
  return (
    <>
      {navItems.map((item) => {
        const href = `/product-categories/${item.slug}`
        return (
          <div key={item.name} className="mb-5 flex flex-col gap-5">
            <Link
              href={href}
              className={cn(
                'text-base uppercase',
                path === href ? 'font-semibold' : 'font-normal',
              )}
            >
              {item.name}
            </Link>

            {item.subitems && !!item.subitems.length && (
              <div className="flex flex-col gap-5 pl-3">
                {item.subitems.map((subitem) => {
                  const href = `/product-categories/${subitem.slug}`
                  return (
                    <Link
                      key={subitem.name}
                      href={href}
                      className={cn(
                        'text-base',
                        path === href ? 'font-semibold' : 'font-normal',
                      )}
                    >
                      {subitem.name}
                    </Link>
                  )
                })}
              </div>
            )}
          </div>
        )
      })}
    </>
  )
}

export default ProductNavigation
